import styled from 'styled-components';

export const Container = styled.div`
  > .ant-card {
    border-radius: 0;
    padding: 24px 0 8px 0;

    .ant-card-body {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      ::after,
      ::before {
        display: none;
      }
    }
  }

  .search-device {
    padding: 32px;
    padding-bottom: 16px;

    .search-device-content {
      position: relative;
      max-width: 380px;
      width: 100%;
      margin: 0 auto;

      .search-type {
        position: absolute;
        top: -20px;
        left: 8px;
        font-size: 0.7rem;
        text-transform: uppercase;

        > span {
          margin-right: 8px;

          transition: 0.2s;
        }

        .search-active {
          font-weight: bold;
          font-size: 0.8rem;
          color: var(--primary-color);
        }
      }
    }
  }

  .devices-tabs {
    display: inline-flex;
    background: green;
  }
`;

export const Content = styled.div`
  padding: 24px;
  padding-top: 32px;

  .ant-badge {
    height: 100%;
  }

  .ant-badge-status-dot {
    width: 18px;
    height: 18px;
  }

  .ant-badge-status {
    vertical-align: middle;
    height: 31px;
  }

  .stat-icon {
    color: ${({ theme }) => theme.colors.primary};
  }

  .ant-title {
    margin-bottom: 0;
  }

  .ant-space {
    width: 100%;
    height: 100%;
  }

  .ant-result {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .ant-col {
    border-radius: 5px;
    overflow: hidden;
  }

  .loading {
    padding: 32px 0;
    text-align: center;
  }

  .search-actions {
    padding: 12px;
    padding-top: 24px;
    width: 100%;
  }

  .actions-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }
  .ant-typography {
    flex: 1;
    margin-bottom: 0;
  }
`;
